"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpWidgetVXSApp = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
const BiMath_1 = require("../libs/BiMath");
const VXSManagerV2Contract_1 = require("../contracts/VXSManagerV2Contract");
const Web3Helper_1 = require("../libs/Web3Helper");
const VXProxyUserV2Contract_1 = require("../contracts/VXProxyUserV2Contract");
const App_1 = require("../App");
const VXInfrastructure_1 = require("../contracts/VXInfrastructure");
class CmpWidgetVXSApp extends tmpls_1.CmpWidgetVXSAppBase {
    constructor() {
        super();
        this._swapPath = [];
        this._app = App_1.App.Inst;
        const ctrl = this.ctrls;
        this._swapPath.push(ctrl.cmpSwapPath0);
        ctrl.cmpSwapPath0.ctrls.btnRemove.hide();
        ctrl.cmpSwapPath0.ctrls.btnAdd.onclick = () => { this._addSwapStep(); };
        App_1.App.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () { this.loadAsync(); }));
        this.ctrls.btnConnect.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnConnect.disable();
            const result = yield App_1.App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
            if (App_1.App.chain.account)
                this.loadAsync();
        });
        this.ctrls.cbUseBurn.onItemClicked.addHandler((e) => {
            if (e.isActive)
                ctrl.blockBnSAddress.hide();
            else
                ctrl.blockBnSAddress.show();
        });
        //********Config*********/
        this.ctrls.cbUseBurn.onItemClicked.addHandler((e) => {
            if (e.isActive)
                ctrl.blockBnSAddress.hide();
            else
                ctrl.blockBnSAddress.show();
        });
        ctrl.iVXSConfig_BnSIndex.el.oninput = () => {
            let value = parseFloat(ctrl.iVXSConfig_BnSIndex.el.value);
            if (value > 1)
                value = 0;
            if (value)
                ctrl.formConfig.q(".config-bns").show();
            else
                ctrl.formConfig.q(".config-bns").hide();
        };
        ctrl.iVXSConfig_SendPLSIndex.el.oninput = () => {
            let value = parseFloat(ctrl.iVXSConfig_SendPLSIndex.el.value);
            if (value > 1)
                value = 0;
            if (value)
                ctrl.formConfig.q(".config-reward").show();
            else
                ctrl.formConfig.q(".config-reward").hide();
        };
        ctrl.btnSubmitStrategy.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield ctrl.formConfig.getFormData(true);
            const invalidFunc = (input = null) => {
                App_1.App.gui.dialogOkShowAsync("One or more inlut field parameters are wrong, click i for more details.");
                if (input)
                    input.addClass("is-invalid");
            };
            const isValidAddress = (address) => { return App_1.App.chain.web3.utils.isAddress(address); };
            const scope = VXSManagerV2Contract_1.VXStrategyScope.NewEmpty();
            //Валидация на sendPLS
            if (!data.uPLSInStake) {
                invalidFunc();
                return;
            }
            else
                scope.uPLSInStake = data.uPLSInStake;
            if (data.sendPLSIndex !== "") {
                const index = parseFloat(data.sendPLSIndex);
                if (index > 1 || index < 0) {
                    invalidFunc();
                    return;
                }
                scope.sendPLSIndex = data.sendPLSIndex;
                if (index == 0)
                    scope.sendPLSReceiver = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                else if (!isValidAddress(data.sendPLSReceiver)) {
                    invalidFunc(ctrl.iVXSConfig_SendPLSReceiver);
                    return;
                }
                else
                    scope.sendPLSReceiver = data.sendPLSReceiver;
            }
            //Валидация на bns
            if (data.bnsIndex !== "") {
                const index = parseFloat(data.bnsIndex);
                if (index > 1 || index < 0) {
                    invalidFunc();
                    return;
                }
                scope.bnsIndex = data.bnsIndex;
                if (index == 0) {
                    scope.swapRouterV2 = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    scope.swapPath = [];
                    scope.swapMinPLSAmount = "0";
                    scope.swapMaxPLSAmount = "0";
                    scope.sendAddress = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    scope.isBurnWithERC20Burn = false;
                }
                else {
                    if (ctrl.rbSwapRouter.value == "pulsexv1")
                        data.swapRouterV2 = VXInfrastructure_1.VXInfrastructure.ADDRESS_PulseXRouterV1;
                    else if (ctrl.rbSwapRouter.value == "pulsexv2")
                        data.swapRouterV2 = VXInfrastructure_1.VXInfrastructure.ADDRESS_PulseXRouterV2;
                    if (!isValidAddress(data.swapRouterV2)) {
                        invalidFunc();
                        return;
                    }
                    else
                        scope.swapRouterV2 = data.swapRouterV2;
                    let path = ["0xA1077a294dDE1B09bB078844df40758a5D0f9a27"];
                    for (const p of this._swapPath) {
                        let spv = p.ctrls.iValue.value;
                        if (!spv) {
                            invalidFunc(p.ctrls.iValue);
                            return;
                        }
                        spv = spv.trim();
                        if (!isValidAddress(spv)) {
                            invalidFunc(p.ctrls.iValue);
                            return;
                        }
                        path.push(spv);
                    }
                    if (new Set(path).size !== path.length) {
                        invalidFunc(ctrl.cmpSwapPath0);
                        return;
                    }
                    if (path.length < 2) {
                        invalidFunc(ctrl.cmpSwapPath0);
                        return;
                    }
                    scope.swapPath = path;
                    const minSwap = parseFloat(data.swapMinPLSAmount);
                    const maxSwap = parseFloat(data.swapMaxPLSAmount);
                    if (minSwap > maxSwap) {
                        invalidFunc(ctrl.iVXSConfig_SwapMinPLSAmount);
                        return;
                    }
                    if (maxSwap < 1) {
                        invalidFunc(ctrl.iVXSConfig_SwapMaxPLSAmount);
                        return;
                    }
                    scope.swapMinPLSAmount = data.swapMinPLSAmount;
                    scope.swapMaxPLSAmount = data.swapMaxPLSAmount;
                    if (ctrl.cbUseBurn.value.indexOf("useBurn") >= 0) {
                        scope.isBurnWithERC20Burn = true;
                        scope.sendAddress = VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress;
                    }
                    else {
                        scope.isBurnWithERC20Burn = false;
                        if (!isValidAddress(data.sendAddress)) {
                            invalidFunc(ctrl.iVXSSConfig_SendAddress);
                            return;
                        }
                        else
                            scope.sendAddress = data.sendAddress;
                    }
                }
            }
            if (parseFloat(scope.bnsIndex) + parseFloat(scope.sendPLSIndex) > 1) {
                App_1.App.gui.dialogOkShowAsync("Index sum of portion distributions equals to 1 or more.");
                return;
            }
            if (scope.swapRouterV2 == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress)
                scope.swapRouterV2 = VXInfrastructure_1.VXInfrastructure.ADDRESS_PulseXRouterV2;
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vxsManagerV2.configureAsync(scope, false));
            if (result) {
                this._successFunc();
                yield this.loadAsync();
            }
        });
        ctrl.btnDepositUPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const uplsValue = ctrl.iVXSConfig_DepositUPLS.value;
            if (!uplsValue) {
                ctrl.iVXSConfig_DepositUPLS.addClass("is-invalid");
                return;
            }
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vxERC20.transfer(this._strategyAdr, uplsValue));
            ctrl.iVXSConfig_DepositUPLS.value = "";
            if (result) {
                this._successFunc();
                yield this.loadAsync();
            }
        });
        ctrl.btnWithdrawPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vxsManagerV2.withdrawPLS());
            if (result) {
                this._successFunc();
                yield this.loadAsync();
            }
        });
        ctrl.btnWithdrawUPLS.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this._strategyAdr)
                return;
            const balance = yield this._vxInf.vxERC20.balanceOf(this._strategyAdr);
            if (!balance)
                return;
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vxsManagerV2.withdrawUPLS(balance));
            if (result) {
                this._successFunc();
                yield this.loadAsync();
            }
        });
        //********Bot*********/
        ctrl.btnSubmitExecutor.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield ctrl.formExecutor.getFormData(false);
            if (!data) {
                App_1.App.gui.dialogOkShowAsync("One or more inlut field parameters are wrong, click ? for more details.");
                return;
            }
            const config = new VXSManagerV2Contract_1.VXStrategyBotConfig();
            config.swapMaxSlippageIndex = "1";
            config.swapFrequencySeconds = parseInt(data.swapFrequencyHours) * 3600;
            config.splitFrequencySeconds = parseInt(data.splitFrequencyHours) * 3600;
            config.splitMinProfitAmount = data.splitMinProfitAmount;
            config.maxGasAmount = data.maxGasAmount;
            const result = yield App_1.App.gui.awaitInLockUIAsync(this._vxInf.vxsManagerV2.configureBotAsync(config));
            if (result) {
                this._successFunc();
                yield this.loadAsync();
            }
        });
    }
    _successFunc() { App_1.App.gui.dialogOkShowAsync("The transaction was completed successfully.", "Information"); }
    _addSwapStep(value) {
        const sp0 = this.ctrls.cmpSwapPath0.ctrls;
        const cmpSwapStep = new tmpls_1.CmpFormItemAddressPath();
        const spn = cmpSwapStep.ctrls;
        spn.lLabel.text = sp0.lLabel.text;
        spn.iValue.el.placeholder = sp0.iValue.el.placeholder;
        spn.btnInfo.ctrls.lText.text = sp0.btnInfo.ctrls.lText.text;
        if (value)
            spn.iValue.value = value;
        spn.btnAdd.hide();
        spn.btnRemove.onclick = () => {
            gs.array.remove(this._swapPath, cmpSwapStep);
            cmpSwapStep.cut();
        };
        this._swapPath.push(cmpSwapStep);
        this.ctrls.blockSwapPath.append(cmpSwapStep);
    }
    loadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._vxInf = App_1.App.Inst.getInst(VXInfrastructure_1.VXInfrastructure);
            const vxInf = this._vxInf;
            const ctrl = this.ctrls;
            ctrl.btnTabStrategy.el.click();
            ctrl.btnTabExecutor.disable();
            ctrl.formConfig.hide();
            ctrl.blockDeposit.hide();
            ctrl.blockWithdraw.hide();
            const account = App_1.App.chain.account;
            if (!account) {
                ctrl.blockConnect.show();
                return;
            }
            else {
                ctrl.blockConnect.hide();
            }
            this._strategyAdr = yield vxInf.vxsManagerV2.getStrategyAdr(App_1.App.chain.account);
            ctrl.iVXSConfig_uPLSInStake.value = "";
            ctrl.iVXSConfig_SendPLSIndex.value = "";
            ctrl.iVXSConfig_SendPLSReceiver.value = "";
            ctrl.iVXSConfig_BnSIndex.value = "";
            ctrl.iVXSConfig_SwapMinPLSAmount.value = "";
            ctrl.iVXSConfig_SwapMaxPLSAmount.value = "";
            ctrl.iVXSSConfig_SendAddress.value = "";
            ctrl.rbSwapRouter.value = "pulsexv2";
            ctrl.cbUseBurn.inactiveAll();
            //remove last path
            ctrl.cmpSwapPath0.ctrls.iValue.value = '';
            for (let i = 1; i < this._swapPath.length; i++)
                this._swapPath[i].cut();
            this._swapPath.splice(1, this._swapPath.length - 1);
            if (this._strategyAdr == VXSManagerV2Contract_1.VXStrategyScope.ZeroAddress) {
                ctrl.btnSubmitStrategy.text = "Create";
                this._strategyAdr = undefined;
                ctrl.formConfig.show();
                ctrl.lVXSConfigStats.hide();
            }
            else {
                ctrl.btnSubmitStrategy.text = "Update";
                ctrl.formConfig.show();
                ctrl.formConfig.disable();
                ctrl.blockDeposit.show();
                ctrl.blockWithdraw.show();
                let info = yield vxInf.vxsManagerV2.getStrategy(this._strategyAdr);
                const scope = info.scope_;
                let path = [...info.scope_.swapPath];
                path.splice(0, 1);
                if (path.length > 0)
                    ctrl.cmpSwapPath0.ctrls.iValue.value = path[0];
                for (let i = 1; i < path.length; i++)
                    this._addSwapStep(path[i]);
                ctrl.iVXSConfig_uPLSInStake.value = scope.uPLSInStake;
                ctrl.iVXSConfig_SendPLSIndex.value = scope.sendPLSIndex;
                ctrl.iVXSConfig_SendPLSReceiver.value = scope.sendPLSReceiver;
                ctrl.iVXSConfig_BnSIndex.value = scope.bnsIndex;
                ctrl.iVXSConfig_SwapMinPLSAmount.value = scope.swapMinPLSAmount;
                ctrl.iVXSConfig_SwapMaxPLSAmount.value = scope.swapMaxPLSAmount;
                ctrl.iVXSSConfig_SendAddress.value = scope.sendAddress;
                ctrl.iVXSConfig_SendPLSIndex.el.dispatchEvent(new Event("input", { bubbles: true }));
                ctrl.iVXSConfig_BnSIndex.el.dispatchEvent(new Event("input", { bubbles: true }));
                if (scope.swapRouterV2 == VXInfrastructure_1.VXInfrastructure.ADDRESS_PulseXRouterV1)
                    ctrl.rbSwapRouter.value = "pulsexv1";
                if (scope.swapRouterV2 == VXInfrastructure_1.VXInfrastructure.ADDRESS_PulseXRouterV2)
                    ctrl.rbSwapRouter.value = "pulsexv2";
                ctrl.lVXSConfigStats.show();
                if (scope.isBurnWithERC20Burn) {
                    ctrl.cbUseBurn.activeByValue("useBurn");
                    ctrl.blockBnSAddress.hide();
                }
                else {
                    ctrl.cbUseBurn.inactiveAll();
                    ctrl.blockBnSAddress.show();
                }
                let uPLSAmount = yield vxInf.vxERC20.balanceOf(this._strategyAdr);
                ctrl.lVXSConfigStrategyAddress.text = this._strategyAdr;
                Web3Helper_1.Web3Helper.ShortLabel(ctrl.lVXSConfigStrategyUPLS, BiMath_1.BiMath.ToBI(uPLSAmount), 3);
                ctrl.formConfig.enable();
                const strategy = new VXProxyUserV2Contract_1.VXProxyUserV2Contract(this._strategyAdr, App_1.App.chain.web3);
                const config = yield strategy.getBotConfig(App_1.App.chain.account);
                if (config) {
                    ctrl.btnTabExecutor.enable();
                    if (config.swapFrequencySeconds == 0) {
                        //?? ctrl.blockVXSTabs.enable();
                        //?? this.activeTab(ctrl.tabVXSConfig);
                        //?? return;
                    }
                    // ctrl.iVXSBot_SwapMaxSlippageIndex.value = config.swapMaxSlippageIndex;
                    ctrl.iVXSBot_SwapFrequencyHours.value = parseInt(config.swapFrequencySeconds / 3600 + "") + "";
                    ctrl.iVXSBot_SplitFrequencyHours.value = parseInt(config.swapFrequencySeconds / 3600 + "") + "";
                    ctrl.iVXSBot_SplitMinProfitAmount.value = config.splitMinProfitAmount;
                    ctrl.iVXSBot_MaxGasAmount.value = config.maxGasAmount;
                    //?    ctrl.blockVXSTabs.enable();
                }
                ctrl.formConfig.validAsync();
                ctrl.formExecutor.validAsync();
            }
        });
    }
}
exports.CmpWidgetVXSApp = CmpWidgetVXSApp;
//# sourceMappingURL=CmpWidgetVXSApp.js.map